export default __webpack_public_path__ + "static/media/buyRent.8578ffea.svg";